module.exports = __webpack_public_path__ + "static/img/dadibannerImg.187c3dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadibannerImg.jpg
// module id = h3Ei
// module chunks = 4